import React from "react";
import nodeHeight from "./node-height";

const nodeHeights = (
  targets: (string | React.RefObject<HTMLElement>)[] | null
) =>
  (Array.isArray(targets) ? targets : [])
    .map(nodeHeight)
    .reduce((acc, cur) => acc + cur, 0);

export default nodeHeights;
